import { render, staticRenderFns } from "./PFileUploader.vue?vue&type=template&id=5b96ffa8&scoped=true&"
import script from "./PFileUploader.vue?vue&type=script&lang=js&"
export * from "./PFileUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b96ffa8",
  null
  
)

export default component.exports